import React, { useState, useEffect, useCallback } from "react";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import api from "../../services/api";
import PageBar from "../../components/common/PageBar";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";

const CommAppManagementPage = () => {
  const navigate = useNavigate();
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const pageSize = 15;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState([]);

  const loadContentData = useCallback(() => {
    setIsLoading(true);

    api
      .post("/manage/commapp/view", {
        pageNo: curPage,
        pageSize: pageSize,
      })
      .then((response) => {
        setDatas(response.data.content);
        setTotalCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch(() => {});
  }, [curPage, pageSize]);

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage, loadContentData, menuAuthInfo.view]);

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleAddFile = () => {
    navigate("/manage/commapp/add");
  };

  const handleDownload = async (ver, dbFileName) => {
    try {
      const response = await api.post(
        "/manage/commapp/download",
        { ver, dbFileName },
        { responseType: "blob" }
      );
      // Content-Disposition 헤더에서 파일명 추출
      let fileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
        }
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Download failed");
    }
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0287")]} />

      <ButtonWrapDiv className="btn_top">
        {menuAuthInfo.reg && (
          <FunctionButton value={t("L0321")} onClick={handleAddFile} />
        )}
      </ButtonWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "5%" }}></col>
              <col style={{ width: "20%" }}></col>
              <col style={{ width: "40%" }}></col>
              <col style={{ width: "10%" }}></col>
              <col style={{ width: "15%" }}></col>
              <col style={{ width: "10%" }}></col>
            </colgroup>
            <thead>
              <tr>
                <th>{t("L0130")}</th>
                <th>{t("L0142")}</th>
                <th>{t("L0143")}</th>
                <th>{t("L0115")}</th>
                <th>{t("L0104")}</th>
                <th>{t("L0322")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, index) => (
                  <tr key={data.id}>
                    <td>{(curPage - 1) * pageSize + index + 1}</td>
                    <td>{data.dbFileName}</td>
                    <td>{data.desc}</td>
                    <td>{data.creId}</td>
                    <td>{data.creDt.split(".")[0]}</td>
                    <td>
                      <Link
                        to="#"
                        onClick={() => {
                          handleDownload(data.ver, data.dbFileName);
                        }}
                      >
                        {t("L0322")}
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        />
      </LoadingBoxDiv>
    </div>
  );
};

export default CommAppManagementPage;
